import { create } from '@bufbuild/protobuf'
import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { MemberSchema } from '~/gen/proto/bff/v1/model_pb'
import MemberEditView from '~/pages/Members/components/MemberEdit'
import { MemberPageHeader } from '~/pages/Members/components/layouts/Header'
import { MemberPageInnerLayout } from '~/pages/Members/components/layouts/Inner'
import { useMemberMutationState } from '~/pages/Members/state/memberMutation'

export const NEW_MEMBER_KEY = 'newMember'

export const MemberCreate: React.FC = () => {
  const { t } = useTranslation()
  const {
    getEditing,
    start: startMemberMutation,
    discard: discardMember,
  } = useMemberMutationState(NEW_MEMBER_KEY)
  const editing =
    getEditing() ??
    startMemberMutation(create(MemberSchema, { id: NEW_MEMBER_KEY }))
  const navigate = useNavigate()
  const onNext = (): void => {
    void navigate({
      to: `/members/create/confirm`,
      params: {
        memberId: editing.id,
      },
    })
  }

  const onCancel = (): void => {
    void navigate({
      to: '/members',
    })
    discardMember()
  }

  return (
    <MemberPageHeader
      breadcrumbItems={[
        {
          label: t('action.add'),
        },
      ]}
    >
      <MemberPageInnerLayout>
        <MemberEditView member={editing} onCancel={onCancel} onNext={onNext} />
      </MemberPageInnerLayout>
    </MemberPageHeader>
  )
}
